import _ from 'lodash';
import { connect } from 'react-redux';
import { search, remove } from '../../modules/logistics/terminal';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => {

	/** @namespace state.lists.terminalIds **/
	/** @namespace state.maps.terminal **/
	/** @namespace state.maps.user **/
	/** @namespace state.maps.supplier **/
	let terminals = [];
	if (state.lists.terminalIds) {
		terminals = _.map(state.lists.terminalIds, id => state.maps.terminal[id]);
	}
	return {
		terminals : _.sortBy(terminals, 'name'),
		userMap : state.maps.user,
		supplierMap : state.maps.supplier,
		authUser : state.auth.authUser,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchTerminals : search,
	removeTerminals : remove,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);